import React, { createContext } from "react";
import { Form, Nav, Tab, Modal } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import Layout from "../../components/Layout";
import { callAPI } from "../../helper/apiUtils";
import { UserFeed } from "./UserFeed";
import { CompanyFeed } from "./CompanyFeed";
import { ReactComponent as ContactIcon } from "../../Icons/ContactIcon.svg";
import { ReactComponent as SmilyIcon } from "../../Icons/SmilyIcon.svg";
import { ReactComponent as BranchIcon } from "../../Icons/BranchIcon.svg";
import ArticleRole from "./Dialogs/ArticleRoles";
import ApproveUsers from "./Dialogs/ApproveUsers";
import { debounce } from "lodash";
import { $crud } from "../../helper/CrudFactory";
import FeedViewDialog from "./Dialogs/FeedViewDialog";
import { connect, useSelector } from "react-redux";
import { ARTICLE, ARTICLE_FEED_SEEN, RIGHT_TOP, SET_COMPANY_ID, SET_COMPANY_IMAGE, SET_OPEN_SIDE_BAR, SET_TAB, SET_VIEWER_IINITAL_INDEX, SET_VIEWER_IMAGES, SET_VIEWER_IS_INTERNAL } from "../../store";
import { $user } from "../../helper/UserFactory";
import { Animated } from "react-animated-css";
import { FilterRoles } from "../../Languages/vars/FilterRoles";
import { getFilterRoles, loadCustomBranches } from "../../helper/customBranches";
import { Scrollbars } from 'react-custom-scrollbars';
import ReactList from 'react-list';
import Virtual from 'react-virtual-dynamic-list'
import ArticleCard from "../../components/ArticleCard";
import InfiniteScroll from 'react-infinite-scroll-component';
import { FixedSizeList as List } from "react-window";
import { ViewportList } from 'react-viewport-list';
import IGRENN from '../../Icons/InternalGreen.png';
import INormal from '../../Icons/Internal-Project.png';
import ExternalOrange from '../../Icons/ExternalOrange.png';
import ExternalNormal from '../../Icons/External-Project.png';
import Tabs from '@mui/material/Tabs';
import ReactTab from '@mui/material/Tab';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { BsChevronLeft, BsChevronRight, BsChevronDoubleUp } from "react-icons/bs";
import RejoinUsersDialoge from "./Dialogs/RejoinUsersDialoge";
import CompanySelectionModal from "./CompanySelectionModal";
import CompanyDocumentsFeedSection from "../../components/CompanyDocumentsFeedSection";
import { canManageCompanyArticle } from "../../helper/articleAdminRights";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { SelectSheet } from "./ToDoProParts";
import {
  ArticleCardPro,
  AudienceCardPro,
  CompanyFilterBar,
  FeedSegmentPro,
  NewPostsPillPro,
  NewsEmptyPro,
  NewsSkeletonPro,
  NewsTitleBar,
} from "./NewsProParts";
import { initialsOf, mediaOf, mediaUrl, toProCard, tr } from "./newsProModel";
import "./Articles.css";


/** Ensure article.likes is always an array (API may return object or single item). */
function ensureLikesArray(likes) {
  if (Array.isArray(likes)) return likes;
  if (likes != null && typeof likes === 'object') return [likes];
  return [];
}

function a11yProps(index, value) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    style: {
      // backgroundColor: (index == 0 && value == index) ? "yellow" : (index == 1 && value == index) ? "blue" : "white",
      color: (index == 1 && value == index) ? "var(--kjuup-internal)" : (index == 0 && value == index) ? "var(--kjuup-accent)" : "grey",
      borderWidth: 0,
      padding: 0,
      textTransform: "none",
      fontSize: "1.8vh",
      bottom: 7
    }
  };
}

let self;

class Articles extends React.Component {
  // static contextType = { ...LanguageContext,...VisibilityContext };
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.handleSearch = debounce(this.handleSearch.bind(this), 100);
    this.myRef = React.createRef();
    this.internalRef = React.createRef();
    this.customRef = React.createRef();
    this.scrollRef = React.createRef();
    this.headerRef = React.createRef();
    this.internalViewportRef = React.createRef();
    this._internalListRefs = {};
    this._visitedInternalCompanies = new Set();
    this._lastScrollTop = 0;
    this._scrollLocked = false;
    this._pendingScrollToArticleId = null;
    this.state = {
      initialLoading: true,
      loadingArticle: false,
      limit: 15,
      page: 1,
      query: "",
      queryInternal: "",
      scrollHeight: 500,
      hasMore: true,
      articles: [],
      emoji: false,
      openFilter: false,
      showRoleDialog: false,
      followings: false,
      followers: false,
      sector: [],
      openRequestDialog: false,
      openRejoinDialoge: false,
      companyRequests: [],
      viewFeed: false,
      rolesData: FilterRoles,
      totalArticles: null,
      value: 0,
      internalArticles: [],
      internalArticlesAll: [],
      showTabs: false,
      isExternalSelected: 0,
      selectedCompanyId: null,
      companies: [],
      page: 1,
      loadingArticle: false,
      hasMore: true,
      pinningArticleIds: {},
      // The article whose PDF is being built (its menu button shows the spinner meanwhile).
      exportingArticleId: null,
      hasAutoSwitchedToInternal: false,
      headerVisible: true,
      showCompanySelectionModal: false,
      showDeleteConfirm: false,
      articleToDelete: null,
      deleteArticleIsInternal: false,
      headerHeight: 98,
      showScrollTop: false,
      // Watermark frozen when the current feed was opened; drives the "NEW"
      // ribbons after the counter has already been cleared.
      frozenSeenAt: { key: null, value: 0 },
      newArticleCount: 0,
      // Article opened from a chat deep link — visually marked in the feed.
      highlightedArticleId: null,
      // Pro header: the article search field (replaces the title row) and its external draft.
      searchOpen: false,
      searchDraft: "",
      companySheetOpen: false,
    };
    // Which feed has already been marked seen, so switching back and forth
    // doesn't re-fire the request.
    this._seenFeedKey = null;
  }

  _clearHeaderScrollLock = () => {
    if (this._headerLockTimeout) {
      clearTimeout(this._headerLockTimeout);
      this._headerLockTimeout = null;
    }
    this._scrollLocked = false;
  };

  _getHeaderHeight = () => {
    const el = this.headerRef.current;
    if (el && el.offsetHeight) return el.offsetHeight;
    return this.state.headerHeight || 98;
  };

  _setHeaderVisible = (visible) => {
    if (this.state.headerVisible === visible) return;
    this._clearHeaderScrollLock();
    this._scrollLocked = true;
    this.setState({ headerVisible: visible }, () => {
      this._headerLockTimeout = setTimeout(() => {
        this._headerLockTimeout = null;
        const element = this.myRef.current;
        if (element) this._lastScrollTop = element.scrollTop;
        this._scrollLocked = false;
      }, 320);
    });
  };

  _onFeedScroll = () => {
    const element = this.myRef.current;
    if (!element) return;

    const currentScrollTop = element.scrollTop;
    const shouldShowScrollTop = currentScrollTop > 250;
    if (shouldShowScrollTop !== this.state.showScrollTop) {
      this.setState({ showScrollTop: shouldShowScrollTop });
    }

    const headerH = this._getHeaderHeight();
    // Stay visible until the bar is fully stuck. Animating `top` before that
    // behaves like relative positioning and the header jumps instead of sliding.
    if (currentScrollTop <= headerH) {
      if (!this.state.headerVisible) {
        this._setHeaderVisible(true);
      }
      this._lastScrollTop = currentScrollTop;
    } else if (!this._scrollLocked && !this._scrollingToTop && !this._scrollingToArticle) {
      const scrollDelta = currentScrollTop - this._lastScrollTop;
      if (Math.abs(scrollDelta) > 12) {
        this._setHeaderVisible(scrollDelta > 0 ? false : true);
        this._lastScrollTop = currentScrollTop;
      }
    }

    const span = element.scrollHeight - element.clientHeight;
    if (span > 0 && element.scrollTop / span > 0.7) {
      if (this.state.value === 0 && !this.state.loadingArticle && this.state.hasMore) {
        this._increasePageNumber();
      }
    }
  };

  _scrollToTop = () => {
    const element = this.myRef.current;
    if (!element) return;

    if (this._scrollTopRaf) {
      cancelAnimationFrame(this._scrollTopRaf);
      this._scrollTopRaf = null;
    }

    const finish = () => {
      this._scrollingToTop = false;
      this._clearHeaderScrollLock();
      element.scrollTop = 0;
      this._lastScrollTop = 0;
      this.setState({ showScrollTop: false, headerVisible: true });
    };

    const start = element.scrollTop;
    if (start <= 0) {
      finish();
      return;
    }

    const duration = Math.min(450, Math.max(180, start * 0.35));
    const startTime = performance.now();
    this._scrollingToTop = true;
    this._clearHeaderScrollLock();
    this._scrollLocked = true;
    // Show header immediately so layout/lock races can't leave it hidden
    if (!this.state.headerVisible) {
      this.setState({ headerVisible: true });
    }

    const step = (now) => {
      const t = Math.min(1, (now - startTime) / duration);
      // Ease-out cubic for a quick, natural deceleration
      const eased = 1 - Math.pow(1 - t, 3);
      element.scrollTop = start * (1 - eased);
      if (t < 1) {
        this._scrollTopRaf = requestAnimationFrame(step);
      } else {
        this._scrollTopRaf = null;
        finish();
      }
    };

    this._scrollTopRaf = requestAnimationFrame(step);
  };

  _measureHeader = () => {
    const el = this.headerRef.current;
    if (el) {
      const h = el.offsetHeight;
      if (h && h !== this.state.headerHeight) this.setState({ headerHeight: h });
    }
  };

  getProfile = async () => {
    const { data } = await callAPI(`/company/my`, {}, "GET");
    if (data.status) {
      this.setState({ companies: data.companies })
    }
  };

  static getDerivedStateFromProps(props, state) {
    if ((props.isExternalSelected !== state.isExternalSelected && state.internalArticles.length > 0) || props.selectedCompanyId !== state.selectedCompanyId) {
      let filteredArticles = state.internalArticles.map((e, i) => {
        if (props.selectedCompanyId !== null)
          return { ...e, isSelected: (e.id == props.selectedCompanyId) ? true : false }
        else
          return { ...e, isSelected: i == 0 ? true : false }
      })
      let ind = filteredArticles.findIndex(e => e.isSelected)
      // No longer need to scroll since CompanySelector uses button layout
      if (filteredArticles.length > 1) {
        return {
          isExternalSelected: props.isExternalSelected,
          value: props.isExternalSelected,
          selectedCompanyId: props.selectedCompanyId,
          internalArticles: [...filteredArticles],
          internalArticlesAll: [...filteredArticles]
        }
      }
      else {
        let tmp = [...filteredArticles]
        if (tmp && tmp.length && tmp.length > 0)
          tmp[0].isSelected = true
        return {
          isExternalSelected: props.isExternalSelected,
          value: props.isExternalSelected,
          selectedCompanyId: props.selectedCompanyId,
          internalArticles: [...tmp],
          internalArticlesAll: [...tmp]
        }
      }
    }
    else {
      return null
    }
  }


  setParam = async (key, value) => {
    await this.setState((state) => {
      return {
        ...state,
        [key]: value,
      };
    });
  };

  get = async () => {
    const { page, limit, query } = this.state;
    const { data } = await callAPI(
      "/article/all",
      {
        page,
        limit,
        query,
        lang: this.context.language || "de",
      },
      "GET"
    );
    if (data.status) {
      const updatedArticles = data.articles.map((article) => {
        article.expand = false;
        // Ensure likes is always an array
        if (!article.likes) {
          article.likes = [];
        } else if (typeof article.likes === 'object' && !Array.isArray(article.likes)) {
          // If likes is an object but not an array, convert it to an array containing that object
          article.likes = [article.likes];
        }
        return article;
      });

      await this.setState({
        articles: [...this.state.articles, ...updatedArticles],
        totalArticles: data?.totalRecords
      });
    } else {
      this.setState({ hasMore: false });
    }
  };

  getInternal = async (ind) => {
    const { pageInternal, limitInternal, queryInternal } = this.state;
    let sindex = (ind || ind == 0) ? ind : 0
    let { data } = await callAPI(
      "/company/getInternalArticle",
      {
        pageInternal,
        limitInternal,
        queryInternal,
        lang: this.context.language || "de",
      },
      "GET"
    );
    console.log('------->Internal Projects', data)
    if (data.status) {
      if (data.articles && data.articles.length > 0) {
        let filteredArticles = data.articles.map((e, i) => {
          if (this.props.selectedCompanyId !== null)
            return { ...e, isSelected: (e.id == this.props.selectedCompanyId) ? true : false }
          else
            return { ...e, isSelected: i == 0 ? true : false }
        })
        if (data.articles.length > 1) {
          data.articles = [...filteredArticles]
        }
        else {
          data.articles[0].isSelected = true
        }
        const updatedArticles = data.articles.map((article) => {
          article.expand = false;
          // Ensure likes is always an array
          if (!article.likes) {
            article.likes = [];
          } else if (typeof article.likes === 'object' && !Array.isArray(article.likes)) {
            // If likes is an object but not an array, convert it to an array containing that object
            article.likes = [article.likes];
          } else if (!Array.isArray(article.likes)) {
            article.likes = [];
          }
          return article;
        });

        if (updatedArticles && updatedArticles.length && updatedArticles.length > 0) {
          this.setState({ showTabs: true })
        }
        else {
          this.setState({ value: 1, showTabs: false })
        }

        await this.setState({
          internalArticles: [...this.state.internalArticles, ...updatedArticles],
          totalArticlesInternal: data?.totalRecords,
        }, () => {
          this.setState({ internalArticlesAll: data.articles }, () => {
            let ind = filteredArticles.findIndex(e => e.isSelected)
          })
        });
      }
      else {
        this.setState({ value: 0, showTabs: false })
      }
    } else {
      this.setState({ hasMoreInternal: false, value: 0, showTabs: false });
    }
  };

  getCompanyRequests = async () => {
    const { data } = await callAPI(
      "/comapny/getUserCompanyRequests",
      {},
      "GET"
    );
    if (data.companyRequests && data.companyRequests.length > 0) {
      await this.setState({ companyRequests: data.companyRequests });
      this.setState({ openRequestDialog: true });
    }
  };


  getRejoinRequest = async () => {
    const { data } = await callAPI(
      `/building/getUserBuildingRequests`,
      {},
      "GET"
    );
    if (data.userBuildingRequest && data.userBuildingRequest.length > 0) {
      await this.setState({ userBuildingRequest: data.userBuildingRequest });
      this.setState({ openRejoinDialoge: true });
    }
  };

  fetchMore = async () => {
    this.setState({ loadingArticle: true });
    if (this.state.hasMore) {
      await this.filter(false, true)
    }
    await this.setState({ loadingArticle: false });
  };

  filter = async (isSelector = false, isHasMore = false) => {
    this.setState({ loadingArticle: true });
    const { emoji, page, limit, sector } = this.state;
    let filterString = "";
    filterString += emoji ? ",emoji" : "";
    filterString += sector.length > 0 ? ",sector" : "";
    const sectors = sector.length > 0 ? sector.join(",") : "";
    if (filterString) {
      const { data } = await callAPI(
        "/article/filter",
        "",
        "POST",
        {
          "flags": filterString,
          sector: sectors,
          page: page > 0 ? page : 0,
          limit,
          lang: this.context.language || "de"
        },
      );
      if (data.status) {
        if (data?.articles?.length < 1) {
          // console.log("claed")
          this.setState({ hasMore: false, loadingArticle: false });
        } else {
          if (isHasMore) {
            const updatedArticles = data.articles.map((article) => {
              article.expand = false;
              // Ensure likes is always an array
              if (!article.likes) {
                article.likes = [];
              } else if (typeof article.likes === 'object' && !Array.isArray(article.likes)) {
                // If likes is an object but not an array, convert it to an array containing that object
                article.likes = [article.likes];
              } else if (!Array.isArray(article.likes)) {
                article.likes = [];
              }
              return article;
            });
            await this.setState((state) => {
              return {
                ...state,
                articles: [...state.articles, ...updatedArticles],
              };
            });
            await this.setState({ loadingArticle: false });
          } else {
            this.setState({ articles: data.articles });
          }
        }
      }
    } else {
      this.get();
      this.setState({ hasMore: true, loadingArticle: false });
    }
    this.setState({ loadingArticle: false });
  };

  setSector = async (sectors) => {
    await this.setParam("sector", sectors);
    this.setState({ articles: [] })
    this.filter(true);
  };

  handleEmoji = async () => {
    await this.setParam("emoji", !this.state.emoji);
    this.filter();
  };

  handleScroll = async () => {
    // console.log("Scroll caaled")
    const element = this.myRef.current;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      const page = this.state.page;
      const newPage = page + 1;
      await this.setState((state) => {
        return {
          ...state,
          page: newPage,
        };
      });
      if (this.state.articles.length < this.state.totalArticles) {
        await this.fetchMore();
      } else {
        this.setState({ hasMore: false })
      }
    }
  };

  _increasePageNumber = async () => {
    const page = this.state.page;
    const newPage = page + 1;
    await this.setState((state) => {
      return {
        ...state,
        page: newPage,
        loadingArticle: true
      };
    });
    if (this.state.articles.length < this.state.totalArticles) {
      await this.fetchMore();
    } else {
      this.setState({ hasMore: false, loadingArticle: false })
    }
  }

  getSavedArticles = () => {
    let savedArticles = localStorage.getItem("savedArticles")
      ? JSON.parse(localStorage.getItem("savedArticles"))
      : [];
    const foundIndex = savedArticles.findIndex(
      (article) => article?.userId === this.props.user?.id
    );
    if (foundIndex > -1) {
      this.setState({ articles: savedArticles[foundIndex].articles });
    }
  };
  goToViolation = (id) => {
    if (id == null) return false;
    const el = document.getElementById(String(id));
    const scroller = this.myRef?.current;
    if (!el || !scroller) return false;

    this._scrollingToArticle = true;
    this._clearHeaderScrollLock();
    this._scrollLocked = true;
    if (this._articleScrollUnlockTimer) {
      clearTimeout(this._articleScrollUnlockTimer);
    }
    this._articleScrollUnlockTimer = setTimeout(() => {
      this._scrollingToArticle = false;
      this._scrollLocked = false;
      this._articleScrollUnlockTimer = null;
      if (this.myRef.current) this._lastScrollTop = this.myRef.current.scrollTop;
    }, 900);

    const scrollFlushUnderHeader = () => {
      const node = document.getElementById(String(id));
      const scrollEl = this.myRef?.current;
      const headerEl = this.headerRef?.current;
      if (!node || !scrollEl) return;
      this._measureHeader();
      const headerH = (headerEl && headerEl.offsetHeight) || this.state.headerHeight || 0;
      const scrollerRect = scrollEl.getBoundingClientRect();
      const nodeRect = node.getBoundingClientRect();
      const target = Math.max(0, nodeRect.top - scrollerRect.top + scrollEl.scrollTop - headerH);
      scrollEl.scrollTo({ top: target, behavior: "smooth" });
    };

    const afterLayout = () => {
      requestAnimationFrame(() => requestAnimationFrame(scrollFlushUnderHeader));
    };

    // Keep the sticky Intern/Extern + search header visible so the card
    // sits flush under it instead of sliding under / leaving a gap.
    if (!this.state.headerVisible) {
      this._setHeaderVisible(true);
      setTimeout(afterLayout, 50);
    } else {
      afterLayout();
    }
    return true;
  }

  isHighlightedArticle = (article) => {
    const id = this.state.highlightedArticleId;
    if (!id || !article) return false;
    return String(article.id) === String(id);
  }

  findInternalArticleIndex = (articleId) => {
    const idStr = String(articleId);
    const companies = this.state.internalArticles || [];
    const company = companies.find((c) =>
      (c.companyArticle || []).some((a) => String(a.id) === idStr)
    );
    if (!company) return -1;
    return (company.companyArticle || []).findIndex((a) => String(a.id) === idStr);
  }

  getScrollToArticleIdFromLocation = (location = this.props.location) => {
    try {
      const params = new URLSearchParams(location?.search || "");
      const fromQuery = params.get("scrollToArticle");
      if (fromQuery) return String(fromQuery);
      if (location?.state?.scrollToArticleId) return String(location.state.scrollToArticleId);
    } catch (_) { /* ignore */ }
    return null;
  }

  clearScrollToArticleFromUrl = () => {
    try {
      const params = new URLSearchParams(this.props.location?.search || "");
      if (!params.has("scrollToArticle") && !params.has("internal")) return;
      params.delete("scrollToArticle");
      params.delete("internal");
      const search = params.toString();
      this.props.history.replace({
        pathname: this.props.location.pathname || "/articles",
        search: search ? `?${search}` : "",
        state: { ...(this.props.location.state || {}), scrollToArticleId: undefined, internal: true },
      });
    } catch (_) { /* ignore */ }
  }

  selectCompanyContainingArticle = (articleId) => {
    const idStr = String(articleId);
    const companies = this.state.internalArticles || [];
    const companyIndex = companies.findIndex((company) =>
      (company.companyArticle || []).some((a) => String(a.id) === idStr)
    );
    if (companyIndex < 0) return false;
    if (companies[companyIndex]?.isSelected) return true;
    const updated = companies.map((c, i) => ({ ...c, isSelected: i === companyIndex }));
    this.setState({ internalArticles: updated, internalArticlesAll: updated });
    if (typeof this.props.setCompanyImage === "function") {
      this.props.setCompanyImage({
        logo: updated[companyIndex]?.logo || null,
        name: updated[companyIndex]?.name || null,
      });
    }
    return true;
  }

  tryScrollToPendingArticle = (attempt = 0) => {
    const articleId = this._pendingScrollToArticleId;
    if (!articleId) return;
    this.selectCompanyContainingArticle(articleId);
    const index = this.findInternalArticleIndex(articleId);
    if (index >= 0 && this.internalViewportRef?.current?.scrollToIndex) {
      try {
        const headerH = this.headerRef?.current?.offsetHeight || this.state.headerHeight || 0;
        this.internalViewportRef.current.scrollToIndex({ index, align: "start", offset: -headerH });
      } catch (_) { /* fallback to DOM scroll below */ }
    }
    const scrolled = this.goToViolation(articleId);
    if (scrolled) {
      this._pendingScrollToArticleId = null;
      this.clearScrollToArticleFromUrl();
      this._freezeWatermark();
      return;
    }
    if (attempt < 12) {
      setTimeout(() => this.tryScrollToPendingArticle(attempt + 1), 150);
    }
  }

  prepareScrollToArticleFromLocation = (location = this.props.location) => {
    const articleId = this.getScrollToArticleIdFromLocation(location);
    if (!articleId) return false;
    this._pendingScrollToArticleId = articleId;
    this.setState({ value: 1, highlightedArticleId: articleId, queryInternal: "" }, () => {
      if (typeof this.props.changeTab === "function") {
        this.props.changeTab(1);
      }
    });
    return true;
  }

  prepareArticle = (article) => {
    const next = { ...article };
    if (!next.likes) next.likes = [];
    else if (typeof next.likes === "object" && !Array.isArray(next.likes)) next.likes = [next.likes];
    else if (!Array.isArray(next.likes)) next.likes = [];
    return next;
  };

  mergeArticlePage = (existing, incoming) => {
    const incomingById = new Map(incoming.map((article) => [String(article.id), article]));
    const existingIds = new Set((existing || []).map((article) => String(article.id)));
    const brandNew = incoming
      .filter((article) => !existingIds.has(String(article.id)))
      .map((article) => ({ ...this.prepareArticle(article), expand: false }));
    const updated = (existing || []).map((article) => {
      const next = incomingById.get(String(article.id));
      if (!next) return article;
      return { ...article, ...this.prepareArticle(next), expand: article.expand };
    });
    return [...brandNew, ...updated];
  };

  refreshFeedsSilently = async () => {
    if (this._silentRefresh) return;
    this._silentRefresh = true;
    try {
      const lang = this.context.language || "de";
      const [externalResult, internalResult] = await Promise.all([
        callAPI("/article/all", { page: 1, limit: this.state.limit, query: this.state.query, lang }, "GET"),
        callAPI("/company/getInternalArticle", {
          pageInternal: 1,
          limitInternal: this.state.limitInternal || this.state.limit,
          queryInternal: this.state.queryInternal,
          lang,
        }, "GET"),
      ]);
      const external = externalResult?.data;
      const internal = internalResult?.data;
      if (!this._didShowFeed) return;

      this.setState((prev) => {
        const next = {};
        if (external?.status && Array.isArray(external.articles)) {
          next.articles = this.mergeArticlePage(prev.articles, external.articles);
          if (external.totalRecords != null) next.totalArticles = external.totalRecords;
        }
        if (internal?.status && Array.isArray(internal.articles) && internal.articles.length > 0) {
          const prevById = new Map((prev.internalArticles || []).map((company) => [String(company.id), company]));
          const incomingIds = new Set();
          const mergedCompanies = internal.articles.map((company, index) => {
            incomingIds.add(String(company.id));
            const previous = prevById.get(String(company.id));
            return {
              ...(previous || {}),
              ...company,
              isSelected: previous ? previous.isSelected : index === 0 && (prev.internalArticles || []).length === 0,
              expand: false,
              companyArticle: this.mergeArticlePage(previous?.companyArticle || [], company.companyArticle || []),
            };
          });
          const rest = (prev.internalArticles || []).filter((company) => !incomingIds.has(String(company.id)));
          next.internalArticles = [...mergedCompanies, ...rest];
          next.internalArticlesAll = next.internalArticles;
          next.showTabs = true;
          if (internal.totalRecords != null) next.totalArticlesInternal = internal.totalRecords;
        }
        return next;
      });
    } catch (err) {
      console.error("Failed to refresh home feed", err);
    } finally {
      this._silentRefresh = false;
    }
  };

  async componentDidMount() {
    self = this;

    loadCustomBranches().then(() => {
      this.setState({ rolesData: getFilterRoles() });
    });

    const hasScrollTarget = this.prepareScrollToArticleFromLocation();

    if (!hasScrollTarget && this.props?.location?.state?.isPosted) {
      if (this.props?.location?.state?.internal) {
        this.setState({ value: 1 })
      }
      else {
        if (this.props?.location?.state?.companyIndex || this.props?.location?.state?.companyIndex == 0) {
          this.setState({ value: 0 })
        }
        else {
          this.setState({ value: 1 })
        }
      }
    }
    else if (!hasScrollTarget) {
      this.setState({ value: 0 })
    }

    await Promise.all([
      this.getProfile(),
      this.get(),
      this.getInternal(this.props?.location?.state?.companyIndex),
      this.getCompanyRequests(),
      this.getRejoinRequest(),
    ]);

    this.setState({ initialLoading: false });
    this._didShowFeed = true;
    // Freeze the NEW-ribbon watermark against the feed that is on screen.
    // If both tabs exist we auto-switch to Internal in componentDidUpdate;
    // mark that tab seen there so we do not clear External first.
    this._freezeWatermark();
    const internalAvailable = Array.isArray(this.state.internalArticles) && this.state.internalArticles.length > 0;
    const externalAvailable = Array.isArray(this.state.articles) && this.state.articles.length > 0;
    const willAutoSwitchToInternal =
      internalAvailable &&
      externalAvailable &&
      this.state.value !== 1 &&
      !this._pendingScrollToArticleId;
    if (!willAutoSwitchToInternal) {
      this.markCurrentFeedSeen();
    }
    window.addEventListener('kjuup:new-article', this._onNewArticleEvent);
    if (this._pendingScrollToArticleId) {
      setTimeout(() => this.tryScrollToPendingArticle(0), 100);
    }

    this._measureHeaderTimer = setTimeout(() => {
      this._measureHeader();
      if (this.headerRef.current && typeof ResizeObserver !== 'undefined') {
        this._headerResizeObserver = new ResizeObserver(() => this._measureHeader());
        this._headerResizeObserver.observe(this.headerRef.current);
      }
    }, 100);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevPath = prevProps.location?.pathname || "";
    const nextPath = this.props.location?.pathname || "";
    const wasHome = prevPath === "/" || prevPath === "/articles";
    const isHome = nextPath === "/" || nextPath === "/articles";
    if (wasHome && !isHome) {
      this.markAllFeedsSeen();
    }
    if (!wasHome && isHome && this._didShowFeed) {
      this.refreshFeedsSilently();
    }

    const prevSearch = prevProps.location?.search || "";
    const nextSearch = this.props.location?.search || "";
    if (prevSearch !== nextSearch || prevProps.location?.state?.scrollToArticleId !== this.props.location?.state?.scrollToArticleId) {
      if (this.prepareScrollToArticleFromLocation()) {
        setTimeout(() => this.tryScrollToPendingArticle(0), 50);
      }
    }

    const internalAvailable = Array.isArray(this.state.internalArticles) && this.state.internalArticles.length > 0;
    const externalAvailable = Array.isArray(this.state.articles) && this.state.articles.length > 0;
    const tabsAvailable = internalAvailable && externalAvailable;

    if (tabsAvailable && !this.state.hasAutoSwitchedToInternal && !this._pendingScrollToArticleId) {
      const shouldSwitch = this.state.value !== 1;
      this.setState(
        {
          value: 1,
          hasAutoSwitchedToInternal: true,
        },
        () => {
          if (shouldSwitch) {
            this.props.changeTab(1);
            // Auto-landing on Internal is navigating to that feed — clear the
            // Home counter instead of waiting for a manual External toggle.
            this.markCurrentFeedSeen();
          }
          const { internalArticles } = this.state;
          if (internalArticles && internalArticles.length > 0) {
            const selectedIndex = internalArticles.findIndex(e => e.isSelected);
            if (selectedIndex !== -1 && !internalArticles[selectedIndex].isLeave) {
              this.props.setCompanyImage({
                logo: internalArticles[selectedIndex].logo,
                name: internalArticles[selectedIndex].name,
              });
            } else if (!internalArticles[0].isLeave) {
              this.props.setCompanyImage({
                logo: internalArticles[0].logo,
                name: internalArticles[0].name,
              });
            }
          }
        }
      );
    }
    if (prevState.value !== this.state.value || prevState.internalArticles?.length !== this.state.internalArticles?.length) {
      setTimeout(() => this._measureHeader(), 50);
      if (this._pendingScrollToArticleId) {
        setTimeout(() => this.tryScrollToPendingArticle(0), 50);
      }
    }

  }

  componentWillUnmount() {
    // Navigating away from the feed counts as having seen it, so every counter
    // clears — external plus all internal companies.
    this.markAllFeedsSeen();
    window.removeEventListener('kjuup:new-article', this._onNewArticleEvent);
    if (this._scrollTopRaf) cancelAnimationFrame(this._scrollTopRaf);
    if (this._headerLockTimeout) clearTimeout(this._headerLockTimeout);
    if (this._articleScrollUnlockTimer) clearTimeout(this._articleScrollUnlockTimer);
    if (this._measureHeaderTimer) clearTimeout(this._measureHeaderTimer);
    if (this._headerResizeObserver) this._headerResizeObserver.disconnect();
    this.setState({ value: this.props.isExternalSelected })
    const articleObj = {
      userId: this.props.user?.id,
      articles: this.state.articles,
    };
    let savedArticles = localStorage.getItem("savedArticles")
      ? JSON.parse(localStorage.getItem("savedArticles"))
      : [];
    const foundIndex = savedArticles?.findIndex((msg) => msg.userId === this.props.user?.id);
    if (foundIndex > -1) {
      savedArticles[foundIndex] = {
        ...savedArticles[foundIndex],
        articles: this.state.articles,
      };
    } else {
      savedArticles = [...savedArticles, articleObj];
    }
    localStorage.setItem("savedArticles", JSON.stringify(savedArticles));
  }

  expandArticle = (key) => {
    const articles = this.state.articles;
    let article = { ...articles[key] };
    article.expand = !article.expand;
    articles[key] = { ...article };
    this.setState({ articles });
  };

  handleFollow = async (id, followStatus) => {
    if (this.state.value == 0) {
      const articleDetails = await this.state.articles.find(
        (article) => article.id === id
      );
      const articlesList = this.state.articles.map((article) => {
        if (article.createdById === articleDetails.createdById) {
          article.followStatus = followStatus ? false : true;
        }
        return article;
      });
      this.setState({ articles: articlesList });
    }
    else {
      let { internalArticles } = this.state
      let ind = internalArticles.findIndex(e => e.isSelected)
      for (let obj of internalArticles[ind].companyArticle) {
        if (obj.userId == id) {
          obj.userFollowStatus = !obj.userFollowStatus
        }
      }
      this.setState({ internalArticles })
    }
  };
  handleLike = async (id) => {
    // Get user info for adding to likes
    const userAvatar = this.props.user?.avatar || this.props.user?.profileImage || this.props.user?.userAvatar || this.props.user?.image;
    const userName = this.props.user?.fullName || this.props.user?.name || 
      (this.props.user?.firstName && this.props.user?.lastName ? 
        `${this.props.user.firstName} ${this.props.user.lastName}` : null);
    const newLikeUser = { 
      id: this.props.user?.id, 
      avatar: userAvatar,
      userFullName: userName,
      firstName: this.props.user?.firstName,
      lastName: this.props.user?.lastName
    };

    if (this.state.value == 0) {
      const articleDetails = this.state.articles.find(
        (article) => article.id === id
      );
      if (!articleDetails) return;
      const articlesList = this.state.articles.map((article) => {
        if (article.id !== articleDetails.id) return article;
        const likes = Array.isArray(article.likes) ? [...article.likes] : [];
        const existUser = likes.find((like) => like.id === this.props.user?.id);
        let newLikes, newCount, newLikeStatus;
        if (existUser) {
          // User already liked -> remove like
          newLikes = likes.filter((like) => like.id !== this.props.user?.id);
          newCount = Math.max(0, (articleDetails.likeCount || 0) - 1);
          newLikeStatus = false;
        } else {
          // User hasn't liked -> add like
          newLikes = [newLikeUser, ...likes];
          newCount = (articleDetails.likeCount || 0) + 1;
          newLikeStatus = true;
        }
        return { ...article, likeStatus: newLikeStatus, likes: newLikes, likeCount: newCount };
      });
      this.setState({ articles: articlesList });
    }
    else {
      let { internalArticles } = this.state;
      const ind = internalArticles.findIndex(e => e.isSelected);
      if (ind === -1) return;
      const articleDetails = internalArticles[ind].companyArticle.find(
        (article) => article.id === id
      );
      if (!articleDetails) return;
      const articlesList = internalArticles[ind].companyArticle.map((article) => {
        if (article.id !== articleDetails.id) return article;
        const likes = Array.isArray(article.likes) ? [...article.likes] : [];
        const existUser = likes.find((like) => like.id === this.props.user?.id);
        let newLikes, newCount, newLikeStatus;
        if (existUser) {
          // User already liked -> remove like
          newLikes = likes.filter((like) => like.id !== this.props.user?.id);
          newCount = Math.max(0, (articleDetails.likeCount || 0) - 1);
          newLikeStatus = false;
        } else {
          // User hasn't liked -> add like at the beginning (newest first)
          // This order matches the reversed API response in LikesDropdown
          newLikes = [newLikeUser, ...likes];
          newCount = (articleDetails.likeCount || 0) + 1;
          newLikeStatus = true;
        }
        return { ...article, likeStatus: newLikeStatus, likes: newLikes, likeCount: newCount };
      });
      const nextInternal = [...internalArticles];
      nextInternal[ind] = { ...nextInternal[ind], companyArticle: articlesList };
      this.setState({ internalArticles: nextInternal });
    }
  };


  setRollData = (data) => {
    this.setState({
      rolesData: data
    })
  }

  handleSearch = async (text) => {
    this.setState({ query: text });
    if (text) {
      const { page, limit } = this.state;
      const { data } = await callAPI(
        "/article/all/search",
        { page, limit, query: text, lang: this.context.language || "de" },
        "GET"
      );
      if (data.status) {
        const updatedArticles = data.articles.map((article) => {
          article.expand = false;
          // Ensure likes is always an array
          if (!article.likes) {
            article.likes = [];
          } else if (typeof article.likes === 'object' && !Array.isArray(article.likes)) {
            // If likes is an object but not an array, convert it to an array containing that object
            article.likes = [article.likes];
          } else if (!Array.isArray(article.likes)) {
            article.likes = [];
          }
          return article;
        });
        this.setState({ articles: updatedArticles });
        this.setState({ hasMore: false });
      } else {
        $crud.notify({
          type: "error",
          message: data.message,
        });
        this.setState({ articles: [] });
      }
    } else {
      // Back to the plain feed: start again from page 1 (get() appends).
      this.setState({ articles: [], page: 1, hasMore: true }, () => this.get());
    }
  };

  renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      borderRadius: 6,
      backgroundColor: 'rgba(var(--kjuup-accent-rgb), 0.8)'
    };
    return <div className="thumb-style" style={{ ...style, ...thumbStyle }} {...props} />;
  };


  // ─── Unseen-article counters ──────────────────────────────────────────────
  //
  // Opening a feed clears its counter immediately, but the "NEW" ribbons have
  // to survive: a badge that says something arrived and then hides which post
  // it was is worse than no badge. So the watermark is frozen BEFORE the feed
  // is marked seen, and cards are compared against that frozen value until the
  // user switches feeds or reloads.
  _activeFeedKey = () => {
    if (this.state.value !== 1) return 'e';
    const selected = this.state.internalArticles.find((e) => e.isSelected);
    const companyId = selected?.id || this.props.selectedCompanyId;
    return companyId ? `i:${companyId}` : null;
  };

  // Snapshot the watermark so cards can keep a NEW ribbon after the Home
  // counter has already been cleared by opening the feed.
  _freezeWatermark = () => {
    const feedKey = this._activeFeedKey();
    if (!feedKey) return;
    const isInternal = this.state.value === 1;
    const companyId = isInternal ? feedKey.slice(2) : null;
    const seenAt = this.props.articleSeenAt || { external: 0, byCompany: {} };
    const frozen = isInternal
      ? (seenAt.byCompany?.[companyId] || 0)
      : (seenAt.external || 0);
    this.setState((prev) => (
      prev.frozenSeenAt?.key === feedKey
        ? null
        : { frozenSeenAt: { key: feedKey, value: frozen } }
    ));
  };

  // Clears the active feed's Home counter. Called when the user opens the
  // feed, switches Internal/External, taps a company chip, or refreshes.
  markCurrentFeedSeen = async () => {
    const feedKey = this._activeFeedKey();
    if (!feedKey) return;
    this._seenFeedKey = feedKey;

    const isInternal = this.state.value === 1;
    const companyId = isInternal ? feedKey.slice(2) : null;
    const seenAt = this.props.articleSeenAt || { external: 0, byCompany: {} };
    // Freeze first — reading the watermark after the optimistic clear would
    // make every card look already-seen.
    const frozen = isInternal
      ? (seenAt.byCompany?.[companyId] || 0)
      : (seenAt.external || 0);
    this.setState((prev) => (
      prev.frozenSeenAt?.key === feedKey
        ? { newArticleCount: 0 }
        : { frozenSeenAt: { key: feedKey, value: frozen }, newArticleCount: 0 }
    ));

    const feedType = isInternal ? 1 : 0;
    this.props.markArticleFeedSeenLocal(feedType, companyId);
    try {
      await callAPI(
        "/article/markFeedSeen",
        companyId ? { feedType, company: companyId } : { feedType },
        "PUT"
      );
    } catch (e) { /* the optimistic clear already updated the UI */ }
  };

  // Clears every article counter at once. An internal markFeedSeen with no
  // company advances the watermark for all of the user's Kjuup+ companies
  // server-side, so two calls cover the whole feed.
  markAllFeedsSeen = () => {
    // Only after the feed actually rendered. A mount that unmounts again before
    // the lists arrive (route churn, a dev double-mount) must not silently mark
    // everything seen.
    if (!this._didShowFeed) return;
    this.props.markArticleFeedSeenLocal(0, null);
    this.props.markArticleFeedSeenLocal(1, null);
    [0, 1].forEach((feedType) => {
      // Fire-and-forget: the optimistic clear above already updated the UI and
      // this runs while the component is going away.
      callAPI("/article/markFeedSeen", { feedType }, "PUT").catch(() => {});
    });
  };

  // The BE sends unseen counts as a list; the chips want a lookup by id.
  unseenArticleByCompanyMap = () => {
    const list = this.props.unSeenAllCount?.unseenArticleByCompany;
    if (!Array.isArray(list)) return {};
    return list.reduce((acc, entry) => {
      if (entry && entry.company) acc[entry.company] = entry.count || 0;
      return acc;
    }, {});
  };

  // A card is "new" when it was published after the watermark frozen on entry.
  // Own posts never qualify — you already know about those.
  isArticleNew = (article) => {
    const { frozenSeenAt } = this.state;
    if (!article || !frozenSeenAt?.value) return false;
    if (frozenSeenAt.key !== this._activeFeedKey()) return false;
    const authorId = article.postedById || article.createdById;
    if (authorId && String(authorId) === String(this.props.user?.id)) return false;
    const publishedAt = Number(article.publishedAt);
    if (!publishedAt || Number.isNaN(publishedAt)) return false;
    return publishedAt > frozenSeenAt.value;
  };

  // Fired by the `articleBadge` socket handler in App.js.
  _onNewArticleEvent = (event) => {
    const detail = event?.detail;
    if (!detail) return;
    const isInternal = this.state.value === 1;
    if (Number(detail.feedType) !== (isInternal ? 1 : 0)) return;
    if (isInternal) {
      const selected = this.state.internalArticles.find((e) => e.isSelected);
      const companyId = selected?.id || this.props.selectedCompanyId;
      if (detail.company && detail.company !== companyId) return;
    }
    this.setState((prev) => ({ newArticleCount: (prev.newArticleCount || 0) + 1 }));
  };

  _onPressNewArticles = () => {
    this.setState({ newArticleCount: 0, frozenSeenAt: { key: null, value: 0 } });
    this._seenFeedKey = null;
    const scroller = this.state.value === 1 ? this.internalRef?.current : this.myRef?.current;
    if (scroller) scroller.scrollTop = 0;
    if (this.state.value === 1) this.getInternal();
    else this.get();
    // Re-arm against the now-advanced watermark so posts arriving after this
    // refresh still get flagged.
    setTimeout(() => this.markCurrentFeedSeen(), 0);
  };

  renderNewArticlesPill = () => (
    <NewPostsPillPro count={this.state.newArticleCount} onClick={this._onPressNewArticles} strings={this.context.strings} />
  );

  handleChange = (newValue) => {
    // A search belongs to the feed it was typed in.
    if (this.state.searchOpen) this.closeSearch();
    this.props.changeTab(newValue)
    this.setState({ value: newValue, highlightedArticleId: null, headerVisible: true }, () => this.markCurrentFeedSeen())
    
    // Set company logo when switching to internal section, clear when switching to external
    if (newValue === 1) {
      const { internalArticles } = this.state
      if (internalArticles && internalArticles.length > 0) {
        const selectedIndex = internalArticles.findIndex(e => e.isSelected)
        if (selectedIndex !== -1 && !internalArticles[selectedIndex].isLeave) {
          this.props.setCompanyImage({
            logo: internalArticles[selectedIndex].logo,
            name: internalArticles[selectedIndex].name,
          })
        } else if (!internalArticles[0].isLeave) {
          this.props.setCompanyImage({
            logo: internalArticles[0].logo,
            name: internalArticles[0].name,
          })
        } else {
          this.props.setCompanyImage(null)
        }
      }
    } else {
      this.props.setCompanyImage(null)
    }
  }


  _onCompanyPress = (index, id) => {
    const item = this.state.internalArticles[index];
    if (!item || item.isSelected) return;
    if (item.isLeave) this.props.setCompanyImage(null);
    else this.props.setCompanyImage({ logo: item.logo, name: item.name });
    this.props.setCompanyId(item.id);
    this.setState({ highlightedArticleId: null }, () => this.markCurrentFeedSeen());
  }

  _internalListRef = (companyId) => {
    if (!this._internalListRefs[companyId]) {
      this._internalListRefs[companyId] = React.createRef();
    }
    return this._internalListRefs[companyId];
  }


  // LeftArrow and RightArrow removed - no longer needed with button-based CompanySelector
  // These components were used for horizontal scrolling which has been replaced with a flex-wrap button layout
  LeftArrow = () => {
    return null;
  }

  RightArrow = () => {
    return null;
  }

  _searchForInternalArticles = async (val) => {
    this.setState({ queryInternal: val }, async () => {
      let { internalArticles, internalArticlesAll } = this.state
      let ind = internalArticles.findIndex(e => e.isSelected)
      const { data } = await callAPI(
        "/company/getInternalArticle",
        {
          // pageInternal,
          // limitInternal,
          search: val,
          lang: this.context.language || "de",
          company_id: internalArticles[ind].id
        },
        "GET"
      );
      if (data.status) {
        let res = data.articles
        let ii = res.findIndex(e => e.id == internalArticles[ind].id)
        let tmp = [...internalArticles]
        tmp[ind].companyArticle = res[ii].companyArticle
        this.setState({
          internalArticles: tmp
        })
      }
    })

  }


  isArticlePinned = (article = {}) => {
    if (!article || typeof article !== "object") {
      return false;
    }
    if (typeof article.isPinned === "boolean") {
      return article.isPinned;
    }
    if (typeof article.pinStatus === "boolean") {
      return article.pinStatus;
    }
    if (typeof article.isPinnedArticle === "boolean") {
      return article.isPinnedArticle;
    }
    if (typeof article.pinnedAt !== "undefined" && article.pinnedAt) {
      return true;
    }
    return false;
  };

  shouldShowPinButton = (article = {}) => {
    if (!article || typeof article !== "object") {
      return false;
    }
    const permissionKeys = [
      "canPin",
      "canPinArticle",
      "canPinInternal",
      "canPinArticleInternal",
      "isPinAllowed",
    ];
    for (const key of permissionKeys) {
      if (typeof article[key] !== "undefined") {
        return Boolean(article[key]);
      }
    }
    return (
      typeof article.pinnedAt !== "undefined" ||
      typeof article.isPinned !== "undefined" ||
      typeof article.pinStatus !== "undefined" ||
      typeof article.isPinnedArticle !== "undefined"
    );
  };

  hasCompanyPinRights = (company = {}) => {
    const role = company?.degination || company?.designation;
    if (!role) {
      return false;
    }
    return (
      role === "COMPANY ADMIN" ||
      role === "COMPANY_DEPARTMENT_ADMIN" ||
      role === "COMPANY SUPER ADMIN" ||
      role === "COMPANY_SUPER_ADMIN"
    );
  };

  hasCompanyManageRights = (company = {}) => {
    if (!company) {
      return false;
    }
    const designation = company.degination || company.designation || company.position;
    if (designation === "EMPLOYEE") {
      return false;
    }
    const role = company.role;
    return (
      designation === "COMPANY ADMIN" ||
      designation === "COMPANY_DEPARTMENT_ADMIN" ||
      designation === "COMPANY SUPER ADMIN" ||
      designation === "COMPANY_SUPER_ADMIN" ||
      role === "ROLE_COMPANY_SUPER_ADMIN" ||
      role === "ROLE_COMPANY_DEPARTMENT_ADMIN"
    );
  };

  getArticleCompanyId = (article = {}) => {
    if (article.createdBy === "company" && article.createdById) {
      return article.createdById;
    }
    if (article.companyId) {
      return article.companyId;
    }
    if (article.company) {
      return typeof article.company === "object" ? article.company.id : article.company;
    }
    return null;
  };

  canManageExternalArticle = (article = {}) => {
    if (!article?.id || article.createdBy === "user") {
      return false;
    }
    const companyId = this.getArticleCompanyId(article);
    if (!companyId) {
      return false;
    }
    const company = (this.state.companies || []).find((item) => item.id === companyId);
    return canManageCompanyArticle(article, company || {}, { isInternal: false });
  };

  getFeedArticleManageProps = ({ article, company = null, companyId = null, isInternal = false }) => {
    if (!article || article.createdBy === "user") {
      return { canManageArticle: false };
    }
    const resolvedCompany = company || (this.state.companies || []).find((item) => item.id === (companyId || this.getArticleCompanyId(article)));
    const canManage = canManageCompanyArticle(article, resolvedCompany || {}, { isInternal });
    const resolvedCompanyId = companyId || company?.id || this.getArticleCompanyId(article);
    return {
      canManageArticle: canManage,
      onEditArticle: canManage
        ? () => this.editFeedArticle({ article, companyId: resolvedCompanyId, isInternal })
        : undefined,
      onDeleteArticle: canManage
        ? () => this.requestDeleteFeedArticle(article, isInternal)
        : undefined,
    };
  };

  editFeedArticle = ({ article, companyId, isInternal }) => {
    const resolvedCompanyId = companyId || this.getArticleCompanyId(article);
    if (!article?.id || !resolvedCompanyId) {
      return;
    }
    this.props.history.push({
      pathname: `/edit-company-article/${resolvedCompanyId}/${article.id}`,
      state: {
        from: isInternal ? "internal" : "external",
        articleType: isInternal ? 1 : 0,
        companyId: resolvedCompanyId,
        fromFeeds: true,
      },
    });
  };

  requestDeleteFeedArticle = (article, isInternal = false) => {
    if (!article?.id) {
      return;
    }
    this.setState({
      showDeleteConfirm: true,
      articleToDelete: article,
      deleteArticleIsInternal: !!isInternal,
    });
  };

  cancelDeleteFeedArticle = () => {
    this.setState({
      showDeleteConfirm: false,
      articleToDelete: null,
      deleteArticleIsInternal: false,
    });
  };

  removeArticleFromFeedState = (articleId) => {
    this.setState((prevState) => {
      const strip = (list) => (list || []).filter((item) => item?.id !== articleId);
      const stripCompany = (companies) =>
        (companies || []).map((company) => ({
          ...company,
          companyArticle: strip(company.companyArticle),
        }));
      return {
        articles: strip(prevState.articles),
        internalArticles: stripCompany(prevState.internalArticles),
        internalArticlesAll: stripCompany(prevState.internalArticlesAll),
      };
    });
  };

  confirmDeleteFeedArticle = async () => {
    const article = this.state.articleToDelete;
    this.setState({ showDeleteConfirm: false });
    if (!article?.id) {
      this.setState({ articleToDelete: null, deleteArticleIsInternal: false });
      return;
    }
    try {
      const { data } = await callAPI(`/article/${article.id}`, {}, "DELETE");
      $crud.notify({
        type: data.status ? "success" : "error",
        message: data.message,
      });
      if (data.status) {
        this.removeArticleFromFeedState(article.id);
      }
    } catch (error) {
      console.error("Failed to delete article", error);
      $crud.notify({
        type: "error",
        message: this.context.isGerm ? "Aktion fehlgeschlagen." : "Failed to delete article.",
      });
    } finally {
      this.setState({ articleToDelete: null, deleteArticleIsInternal: false });
    }
  };

  setPinLoadingState = (articleId, value) => {
    if (!articleId) {
      return;
    }
    this.setState((prevState) => ({
      pinningArticleIds: {
        ...prevState.pinningArticleIds,
        [articleId]: value,
      },
    }));
  };


  refreshInternalCompanyArticles = async (companyId, providedIndex) => {
    if (!companyId) {
      return;
    }
    try {
      const { data } = await callAPI(
        "/company/getInternalArticle",
        {
          lang: this.context.language || "de",
          company_id: companyId,
          search: this.state.queryInternal,
        },
        "GET"
      );
      if (data?.status && Array.isArray(data?.articles)) {
        const updatedCompany = data.articles.find((item) => item.id === companyId);
        if (!updatedCompany) {
          return;
        }
        const normalizedArticles = (updatedCompany.companyArticle || []).map((article) => {
          const normalizedArticle = { ...article };
          if (!normalizedArticle.likes) {
            normalizedArticle.likes = [];
          } else if (typeof normalizedArticle.likes === "object" && !Array.isArray(normalizedArticle.likes)) {
            normalizedArticle.likes = [normalizedArticle.likes];
          } else if (!Array.isArray(normalizedArticle.likes)) {
            normalizedArticle.likes = [];
          }
          return normalizedArticle;
        });
        this.setState((prevState) => {
          const internalArticles = [...prevState.internalArticles];
          const internalArticlesAll = [...prevState.internalArticlesAll];
          const resolvedIndex =
            typeof providedIndex === "number"
              ? providedIndex
              : internalArticles.findIndex((item) => item.id === companyId);
          if (resolvedIndex === -1) {
            return null;
          }
          const existingCompany = internalArticles[resolvedIndex] || {};
          internalArticles[resolvedIndex] = {
            ...existingCompany,
            companyArticle: normalizedArticles,
          };
          const allIndex = internalArticlesAll.findIndex((item) => item.id === companyId);
          if (allIndex !== -1) {
            const existingAllCompany = internalArticlesAll[allIndex] || {};
            internalArticlesAll[allIndex] = {
              ...existingAllCompany,
              companyArticle: normalizedArticles,
            };
          }
          return {
            internalArticles,
            internalArticlesAll,
          };
        });
      }
    } catch (error) {
      console.error("Failed to refresh internal articles", error);
    }
  };

  toggleInternalArticlePin = async ({ article, companyId, companyIndex }) => {
    if (!article || !article.id) {
      return;
    }
    const articleId = article.id;
    const currentlyPinned = this.isArticlePinned(article);
    this.setPinLoadingState(articleId, true);
    const payload = {};
    if (!currentlyPinned) {
      const currentTimestampInSeconds = Math.floor(Date.now() / 1000);
      payload.pinnedDuration = `${currentTimestampInSeconds}`;
    }
    const nextPinnedState = !currentlyPinned;
    const optimisticPinnedAt = nextPinnedState ? `${Math.floor(Date.now() / 1000)}` : null;
    try {
      const { data } = await callAPI(
        `/article/${articleId}/pinUnpinArticle`,
        payload,
        "PUT"
      );
      if (data?.status) {
        this.setState((prevState) => {
          const internalArticles = [...prevState.internalArticles];
          const internalArticlesAll = [...prevState.internalArticlesAll];
          const nowTimestamp = optimisticPinnedAt;
          const updateCollection = (collection) => {
            const resolvedIndex =
              typeof companyIndex === "number"
                ? companyIndex
                : collection.findIndex((item) => item.id === companyId);
            if (resolvedIndex === -1 || !collection[resolvedIndex]) {
              return;
            }
            const companyEntry = { ...collection[resolvedIndex] };
            const articlesList = [...(companyEntry.companyArticle || [])];
            const articleIndex = articlesList.findIndex((item) => item.id === articleId);
            if (articleIndex === -1) {
              return;
            }
            const updatedArticle = { ...articlesList[articleIndex] };
            if (Object.prototype.hasOwnProperty.call(updatedArticle, "isPinned")) {
              updatedArticle.isPinned = nextPinnedState;
            }
            if (Object.prototype.hasOwnProperty.call(updatedArticle, "pinStatus")) {
              updatedArticle.pinStatus = nextPinnedState;
            }
            if (Object.prototype.hasOwnProperty.call(updatedArticle, "isPinnedArticle")) {
              updatedArticle.isPinnedArticle = nextPinnedState;
            }
            if (nextPinnedState || Object.prototype.hasOwnProperty.call(updatedArticle, "pinnedAt")) {
              updatedArticle.pinnedAt = nowTimestamp;
            }
            articlesList.splice(articleIndex, 1);
            if (nextPinnedState) {
              articlesList.unshift(updatedArticle);
            } else {
              const reinsertionIndex = Math.min(articleIndex, articlesList.length);
              articlesList.splice(reinsertionIndex, 0, updatedArticle);
            }
            companyEntry.companyArticle = articlesList;
            collection[resolvedIndex] = companyEntry;
          };
          updateCollection(internalArticles);
          updateCollection(internalArticlesAll);
          return {
            internalArticles,
            internalArticlesAll,
          };
        });
        await this.refreshInternalCompanyArticles(companyId, companyIndex);
        if (data?.message) {
          $crud.notify({
            type: "success",
            message: data.message,
          });
        }
      } else {
        $crud.notify({
          type: "error",
          message:
            data?.message ||
            (this.context.isGerm ? "Aktion fehlgeschlagen." : "Unable to update pin status."),
        });
      }
    } catch (error) {
      console.error("Failed to toggle pin status", error);
      $crud.notify({
        type: "error",
        message: this.context.isGerm ? "Aktion fehlgeschlagen." : "Failed to toggle pin status.",
      });
    } finally {
      this.setPinLoadingState(articleId, false);
    }
  };

  // ─── Pro News (mobile upgrade/rn-0.87 look) ───────────────────────────────

  _selectedCompany = () =>
    this.state.internalArticles.find((e) => e.isSelected) || this.state.internalArticles[0] || null;

  _visibleInternalArticles = (company) => {
    const list = company?.companyArticle || [];
    const q = (this.state.queryInternal || '').trim().toLowerCase();
    if (!q) return list;
    return list.filter((a) => {
      const title = (a.title || '').toLowerCase();
      const desc = (a.description || '').replace(/<[^>]*>/g, '').toLowerCase();
      return title.includes(q) || desc.includes(q);
    });
  };

  // Companies the user may post for externally: Kjuup+ companies they administrate.
  _postingCompanies = () =>
    (this.state.companies || []).filter((company) =>
      ((company.position == 'COMPANY ADMIN') || (company.role === 'ROLE_COMPANY_DEPARTMENT_ADMIN')) && company.isKjuup
    );

  canPost = () => {
    if (this.state.value == 1) {
      const selected = this.state.internalArticles.find((e) => e.isSelected);
      return selected?.degination == 'COMPANY ADMIN' || selected?.degination == 'COMPANY_DEPARTMENT_ADMIN';
    }
    return this._postingCompanies().length > 0;
  };

  onPostClick = () => {
    if (this.state.value == 1) {
      const mainIndex = this.state.internalArticles.findIndex(e => e.isSelected);
      const mainItem = this.state.internalArticles[mainIndex];
      if (!mainItem) return;
      this.props.history.push({
        pathname: `/add-company-article/${mainItem.id}`,
        state: { from: "internal", articleType: 1, companyId: mainItem.id, companyIndex: mainIndex, fromFeeds: true }
      });
      return;
    }
    const companiesWithRights = this._postingCompanies();
    if (companiesWithRights.length === 1) {
      // Only one company - go directly to create article
      this.props.history.push({
        pathname: `/add-company-article/${companiesWithRights[0].id}`,
        state: { from: "external", companyId: companiesWithRights[0].id, fromFeeds: true }
      });
    } else if (companiesWithRights.length > 1) {
      // Multiple companies - show selection modal
      this.setState({ showCompanySelectionModal: true });
    }
  };

  // The title row's article search: External runs the server search, Internal filters the company feed.
  onSearchChange = (val) => {
    if (this.state.value == 1) {
      this._searchForInternalArticles(val);
    } else {
      this.setState({ searchDraft: val });
      this.handleSearch(val);
    }
  };

  closeSearch = () => {
    const internal = this.state.value == 1;
    const term = internal ? this.state.queryInternal : this.state.searchDraft;
    this.setState({ searchOpen: false, searchDraft: "" });
    if (!term) return;
    if (internal) this._searchForInternalArticles("");
    else this.handleSearch("");
  };

  likeFeedArticle = async (article) => {
    if (!article?.id || String(this.props.user?.id) === String(article.postedById)) return;
    this.handleLike(article.id);
    try {
      await callAPI(`/article/${article.id}/like`, { id: article.id, emoji: 6, lang: "en" }, "GET");
    } catch (err) {
      this.handleLike(article.id);
    }
  };

  dmArticleUser = (id, article) => {
    if (!id) return;
    requestDirectMessage({
      id,
      fullName: article.postedByName || article.fullName || `${article.firstName || ""} ${article.lastName || ""}`.trim(),
      avatar: article.avatar || article.postedByAvatar || article.postedByImage,
    });
  };

  // External company post: the user's own company opens in the Cockpit, any other its profile.
  openArticleCompany = (article) => {
    const createdById = article.userId ? article.userId : article.createdById;
    this.props.clearRightPanel();
    const companies = $user.getUserProfile()?.companies || [];
    const own = companies.find((c) => c.id === createdById);
    if (own) {
      this.props.history.push({
        pathname: "/cockpit",
        search: `?tab=company&company=${encodeURIComponent(own.id)}`,
        state: article.id,
      });
    } else {
      this.props.history.push({ pathname: `/foreign-company-details/${createdById}`, state: article.id });
    }
  };

  onArticleAuthor = (article, internal) => {
    if (internal) {
      this.dmArticleUser(article.userId || article.postedById || article.createdById, article);
    } else if (article.createdBy === "company") {
      this.openArticleCompany(article);
    } else {
      this.dmArticleUser(article.postedById || article.createdById, article);
    }
  };

  // The article as a PDF download, laid out like the card: byline, images, title, text.
  exportArticlePdf = async (article, { internal, company = null }) => {
    if (!article || this.state.exportingArticleId) return;
    const s = this.context.strings;
    const locale = this.context.language || (this.context.isGerm ? "de" : "en");
    const card = toProCard(article, {
      internal,
      company: internal && company ? { name: company.name, logo: company.logo } : null,
      isGerm: this.context.isGerm,
      strings: s,
      locale,
      userId: this.props.user?.id,
    });
    const date = article.createdAt ? new Date(article.createdAt) : null;
    const when =
      date && !Number.isNaN(date.getTime())
        ? date.toLocaleDateString(locale, { day: "2-digit", month: "long", year: "numeric" })
        : "";
    const poster = internal || article.createdBy === "company" ? article.postedByName : "";
    const byline = [card.head?.name, poster, when].filter(Boolean).join(" · ");
    this.setState({ exportingArticleId: article.id });
    try {
      // Loaded on demand: pdfmake is large and only needed here.
      const { downloadArticlePdf } = await import("../../utils/articlePdf");
      await downloadArticlePdf(article, {
        title: card.title,
        byline,
        labels: {
          attachments: tr(s, "pro_news_pdf_attachments", "Attachments"),
          video: tr(s, "pro_news_pdf_video", "Video"),
        },
      });
    } catch (err) {
      console.error("Article PDF failed:", err);
      $crud.notify({ type: "error", message: tr(s, "pro_news_pdf_failed", "The PDF could not be created.") });
    } finally {
      this.setState({ exportingArticleId: null });
    }
  };

  // Card menu: "Export as PDF" for everyone, then what the user may change (pin, edit, delete).
  // The likes list opens from the like count under the post.
  articleMenuRows = (article, { internal, company = null, companyIndex = null }) => {
    const s = this.context.strings;
    const rows = [
      {
        key: "pdf",
        icon: "picture_as_pdf",
        label: tr(s, "pro_news_export_pdf", "Export as PDF"),
        onClick: () => this.exportArticlePdf(article, { internal, company }),
      },
    ];
    if (internal && company && this.hasCompanyPinRights(company) && this.shouldShowPinButton(article)) {
      const pinned = this.isArticlePinned(article);
      rows.push({
        key: "pin",
        icon: "keep",
        label: pinned ? tr(s, "pro_news_unpin", "Unpin") : tr(s, "pro_news_pin", "Pin"),
        onClick: () => {
          if (!this.state.pinningArticleIds[article.id]) {
            this.toggleInternalArticlePin({ article, companyId: company.id, companyIndex });
          }
        },
      });
    }
    const manage = internal
      ? this.getFeedArticleManageProps({ article, company, companyId: company?.id, isInternal: true })
      : this.getFeedArticleManageProps({ article, isInternal: false });
    if (manage.canManageArticle && manage.onEditArticle && manage.onDeleteArticle) {
      rows.push({ key: "edit", icon: "edit_square", label: tr(s, "edit", "Edit"), onClick: manage.onEditArticle });
      rows.push({ key: "delete", icon: "delete", label: tr(s, "delete_label", "Delete"), danger: true, onClick: manage.onDeleteArticle });
    }
    return rows;
  };

  renderArticleCard = (article, key, { internal, company = null, companyIndex = null }) => {
    const s = this.context.strings;
    const card = toProCard(article, {
      internal,
      company: internal && company ? { name: company.name, logo: company.logo } : null,
      isGerm: this.context.isGerm,
      strings: s,
      locale: this.context.language || (this.context.isGerm ? "de" : "en"),
      userId: this.props.user?.id,
    });
    return (
      <ArticleCardPro
        article={article}
        card={card}
        media={mediaOf(article)}
        isNew={this.isArticleNew(article)}
        pinned={internal && this.isArticlePinned(article)}
        pinBusy={!!this.state.pinningArticleIds[article.id] || this.state.exportingArticleId === article.id}
        highlighted={this.isHighlightedArticle(article)}
        searchTerm={internal ? this.state.queryInternal : this.state.query}
        strings={s}
        menuRows={this.articleMenuRows(article, { internal, company, companyIndex })}
        onLike={() => this.likeFeedArticle(article)}
        onAuthor={() => this.onArticleAuthor(article, internal)}
        // External company posts: the poster's name opens a DM (the header opens the company).
        onPoster={!internal && article.createdBy === "company" ? () => this.dmArticleUser(article.postedById, article) : undefined}
        onOpenMedia={(visual, index) => this.props.openViewer(visual.map((v) => v.item), index, internal)}
      />
    );
  };

  _renderFeedTop = (count, term) => {
    const s = this.context.strings;
    // Posts follow the tabs directly; only an empty feed gets a message here.
    if (count) return null;
    return (
      <NewsEmptyPro
        icon={term ? "search_off" : "brand_awareness"}
        title={tr(s, "pro_news_empty_title", "No article found")}
        hint={term ? tr(s, "pro_news_empty_search_hint", "Try a different search term.") : null}
      />
    );
  };

  renderProHeader = () => {
    const s = this.context.strings;
    const { value, internalArticles, showTabs, searchOpen } = this.state;
    const internal = value == 1;
    const selected = internal ? this._selectedCompany() : null;
    const searchLabel = internal
      ? tr(s, "pro_news_search_internal", "Search internal news")
      : tr(s, "pro_news_search_external", "Search news");
    // The field names its scope: the selected company on Internal, the external feed otherwise.
    const placeholder = internal && selected?.name
      ? tr(s, "pro_news_search_in", "Search {0}").replace("{0}", selected.name)
      : searchLabel;
    const term = internal ? this.state.queryInternal : this.state.searchDraft;
    let countLabel = null;
    if (term && term.trim()) {
      const n = internal
        ? this._visibleInternalArticles(selected).length
        : (this.state.query === term ? this.state.articles.length : null);
      if (n != null) {
        countLabel = n === 1
          ? tr(s, "pro_news_search_count_one", "1 post")
          : tr(s, "pro_news_search_count_many", "{0} posts").replace("{0}", n);
      }
    }

    const segment = showTabs ? (
      <FeedSegmentPro
        value={internal ? "internal" : "external"}
        onPress={(key) => {
          const next = key === "internal" ? 1 : 0;
          if (next !== value) this.handleChange(next);
          else this.markCurrentFeedSeen();
        }}
        items={[
          { key: "external", icon: "public", label: tr(s, "pro_news_external", "External"), count: this.props.unSeenAllCount?.unseenArticleExternal || 0 },
          { key: "internal", icon: "domain", label: tr(s, "pro_news_internal", "Internal"), count: this.props.unSeenAllCount?.unseenArticleInternal || 0 },
        ]}
      />
    ) : null;

    let company = null;
    if (internal && selected && internalArticles.length > 1) {
      const unseen = this.unseenArticleByCompanyMap();
      const otherNew = internalArticles.reduce((sum, c) => (c.id === selected.id ? sum : sum + (Number(unseen[c.id]) || 0)), 0);
      company = (
        <CompanyFilterBar
          company={{ name: selected.name, logoUri: mediaUrl(selected.logo), initials: initialsOf(selected.name) }}
          label={tr(s, "pro_news_company_showing", "Showing articles of {name}").replace("{name}", selected.name || "")}
          otherNew={otherNew}
          otherNewLabel={
            otherNew === 1
              ? tr(s, "pro_news_company_other_one", "1 new post in another company")
              : tr(s, "pro_news_company_other_n", "{n} new posts in other companies").replace("{n}", otherNew)
          }
          onClick={() => this.setState({ companySheetOpen: true })}
        />
      );
    }

    const companyId = internal ? (selected?.id || this.props.selectedCompanyId) : null;
    if (companyId) {
      try {
        sessionStorage.setItem("kjuup_intern_docs_company_id", companyId);
      } catch (_) { /* ignore */ }
    }

    return (
      <>
        <NewsTitleBar
          title={s.nav_news || "News"}
          strings={s}
          search={{
            open: searchOpen,
            label: searchLabel,
            placeholder,
            value: term || "",
            countLabel,
            onToggle: () => (searchOpen ? this.closeSearch() : this.setState({ searchOpen: true })),
            onChange: this.onSearchChange,
            onClose: this.closeSearch,
          }}
          post={this.canPost() ? { label: tr(s, "pro_news_post", "Post"), onClick: this.onPostClick } : null}
        />
        <AudienceCardPro
          segment={segment}
          company={company}
          documents={companyId ? <CompanyDocumentsFeedSection key={companyId} companyId={companyId} /> : null}
        />
      </>
    );
  };

  renderCompanySheet = () => {
    const s = this.context.strings;
    const unseen = this.unseenArticleByCompanyMap();
    const selected = this._selectedCompany();
    return (
      <SelectSheet
        open={this.state.companySheetOpen}
        title={tr(s, "pro_news_company_pick", "Choose company")}
        items={this.state.internalArticles.map((c) => {
          const n = Number(unseen[c.id]) || 0;
          return {
            key: c.id,
            title: c.name,
            sub: n
              ? (n === 1 ? tr(s, "pro_news_company_new_one", "1 new post") : tr(s, "pro_news_company_new_n", "{n} new posts").replace("{n}", n))
              : undefined,
            avatar: { name: c.name, src: mediaUrl(c.logo) },
          };
        })}
        value={selected?.id}
        onChange={(key) => {
          const index = this.state.internalArticles.findIndex((c) => String(c.id) === String(key));
          if (index >= 0) this._onCompanyPress(index, key);
        }}
        onClose={() => this.setState({ companySheetOpen: false })}
        searchPlaceholder={tr(s, "pro_news_company_search", "Search company")}
        clearLabel={tr(s, "pro_news_clear_search", "Clear search")}
        closeLabel={tr(s, "cancel", "Cancel")}
        emptyText={tr(s, "pro_news_company_none", "No company found")}
      />
    );
  };

  _renderInternal = () => {
    return (
      <div>
        {
          this.state.internalArticles.map((mainItem, mainIndex) => {
            if (mainItem.isSelected) this._visitedInternalCompanies.add(mainItem.id);
            if (!mainItem.isSelected && !this._visitedInternalCompanies.has(mainItem.id)) {
              return null;
            }
            const visibleArticles = this._visibleInternalArticles(mainItem);
            const listRef = this._internalListRef(mainItem.id);
            return (
              <div
                key={mainItem.id}
                className="articles-internal-list"
                ref={(el) => {
                  listRef.current = el;
                  if (mainItem.isSelected) this.internalRef.current = el;
                }}
                style={mainItem.isSelected ? undefined : { display: 'none' }}
                aria-hidden={!mainItem.isSelected}
              >
                {this._renderFeedTop(visibleArticles.length, this.state.queryInternal)}
                <ViewportList
                  ref={mainItem.isSelected ? this.internalViewportRef : undefined}
                  viewportRef={listRef}
                  items={visibleArticles}
                  withCache
                >
                  {(article, key) => (
                    <div
                      key={article?.id ? `article-${article.id}` : `article-${mainItem.id}-${key}`}
                      className="np-row"
                      id={article.id}
                    >
                      {this.renderArticleCard(article, key, { internal: true, company: mainItem, companyIndex: mainIndex })}
                    </div>
                  )}
                </ViewportList>
              </div>
            )
          })
        }
      </div>
    )
  }

  _renderNoraml = () => {
    const { articles, query, loadingArticle } = this.state;
    return (
      <div className="articles-normal-list">
        <div className="articles-normal-list-inner">
          {this._renderFeedTop(articles.length, query)}
          <ViewportList
            viewportRef={this.myRef}
            items={articles}
            withCache
          >
            {(article, key) => (
              <div
                key={article?.id ? `article-${article.id}` : key}
                className="np-row"
                id={article.id}
              >
                {this.renderArticleCard(article, key, { internal: false })}
              </div>
            )}
          </ViewportList>
          {loadingArticle && articles.length ? (
            <div className="np-footer">
              <span className="np-spinner" />
            </div>
          ) : null}
        </div>
      </div>
    )
  }


  render() {
    const { value, initialLoading } = this.state;
    const isDesktop = this.props.isDeskTopResolution;


    return (
      <React.Fragment>
        <div className="feed-scroll-wrapper">
        <div
          className='scroll feed-content-fade-in articles__scroll'
          ref={this.myRef}
          onScroll={this._onFeedScroll}
        >
          {/* {this.props.isDeskTopResolution && <div style={{ flex: 1, }} />} */}
          <div className={`np articles__column${isDesktop ? ' articles__column--desktop' : ''}`}>
            <div
              ref={this.headerRef}
              className={`feed-header-container${this.state.headerVisible ? '' : ' is-hidden'}`}
            >
              <div className="feed-header-slide np-header">
                {this.renderProHeader()}
              </div>
            </div>
            <div className="articles-content-area">
              {initialLoading ? (
                <div className="np-feed">
                  <NewsSkeletonPro />
                </div>
              ) : (
                <div className="np-feed">
                  {this.renderNewArticlesPill()}
                  {
                    value == 1 ?
                      this._renderInternal()
                      :
                      this._renderNoraml()
                  }
                </div>
              )}
            </div>
          </div>
          {this.props.isDeskTopResolution && <div className="kj-flex-1" />}
        </div>
        {this.state.showScrollTop && (
          <div
            className={`feed-scroll-top-slot${isDesktop ? ' articles__scroll-top-slot--desktop' : ''}`}
          >
            <button
              type="button"
              className="kj-btn kj-btn--icon kj-btn--lg kj-btn--on-surface feed-scroll-top-btn"
              onClick={this._scrollToTop}
              aria-label="Scroll to top"
            >
              <BsChevronDoubleUp size={22} />
            </button>
          </div>
        )}
        </div>
        {this.state.openRequestDialog && (
          <ApproveUsers
            handleClose={(e) => {
              this.setState({ openRequestDialog: false });
            }}
            companyRequests={this.state.companyRequests}
          />
        )}
        {this.state.openRejoinDialoge && (
          <RejoinUsersDialoge
            handleClose={(e) => {
              this.setState({ openRejoinDialoge: false });
            }}
            companyRequests={this.state.userBuildingRequest}
          />
        )}
        {this.state.showRoleDialog && (
          <ArticleRole
            handleClose={() => {
              this.setState({ showRoleDialog: false });
            }}
            selectSector={this.setSector}
            selectedSector={this.state.sector}
            rolesData={this.state.rolesData}
            setRollData={this.setRollData}
            setParam={this.setParam}
          />
        )}
        {this.props.article && (
          <FeedViewDialog 
            article={this.props.article} 
            articlesList={this.props.articlesList || []}
            currentArticleIndex={this.props.currentArticleIndex || 0}
          />
        )}
        {this.renderCompanySheet()}
        {this.state.showCompanySelectionModal && (
          <CompanySelectionModal
            companies={this.state.companies.filter(company => 
              ((company.position == 'COMPANY ADMIN') || (company.role === 'ROLE_COMPANY_DEPARTMENT_ADMIN')) && company.isKjuup
            )}
            onClose={() => this.setState({ showCompanySelectionModal: false })}
          />
        )}
        <Modal
          show={this.state.showDeleteConfirm}
          onHide={this.cancelDeleteFeedArticle}
          animation={false}
          centered
          dialogClassName="modal-dialog-centered np"
        >
          <Modal.Body className="modal-body-relative">
            <p className="np-confirm-text">{this.context.strings.delete_article_confirm}</p>
          </Modal.Body>
          <Modal.Footer className="articles__delete-footer">
            <div className="np-confirm-actions">
              <button type="button" className="kj-btn kj-btn--secondary" onClick={this.cancelDeleteFeedArticle}>
                {tr(this.context.strings, "cancel", "Cancel")}
              </button>
              <button type="button" className="kj-btn kj-btn--primary kj-btn--danger" onClick={this.confirmDeleteFeedArticle}>
                {tr(this.context.strings, "delete_label", "Delete")}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </React.Fragment >
    );
  }
}

const mapStateToProps = (state) => {
  const { article, drawerOpen, isExternalSelected, selectedCompanyId, user, isDeskTopResolution, articlesList, currentArticleIndex, unSeenAllCount, joinRequestsExternal, joinRequestsInternal } = state;
  return {
    article: article,
    drawerOpen: drawerOpen,
    isExternalSelected,
    selectedCompanyId,
    user: user,
    isDeskTopResolution: isDeskTopResolution,
    articlesList: articlesList,
    currentArticleIndex: currentArticleIndex,
    unSeenAllCount: unSeenAllCount,
    articleSeenAt: state.articleSeenAt,
    joinRequestsExternal: joinRequestsExternal,
    joinRequestsInternal: joinRequestsInternal,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    viewArticle: (article, articlesList, currentIndex) => dispatch({ 
      type: ARTICLE, 
      article: article,
      articlesList: articlesList || [],
      currentArticleIndex: currentIndex !== undefined ? currentIndex : 0
    }),
    changeTab: (status) => dispatch({ type: SET_TAB, status: status }),
    setCompanyImage: (status) => dispatch({ type: SET_COMPANY_IMAGE, payload: status }),
    setCompanyId: (id) => dispatch({ type: SET_COMPANY_ID, payload: id }),
    markArticleFeedSeenLocal: (feedType, company) =>
      dispatch({ type: ARTICLE_FEED_SEEN, feedType, company }),
    // The card media opens the full-screen viewer (photos and videos, no PDFs).
    openViewer: (items, index, isInternal) => {
      dispatch({ type: SET_VIEWER_IINITAL_INDEX, index });
      dispatch({ type: SET_VIEWER_IMAGES, ViewerImages: items });
      dispatch({ type: SET_VIEWER_IS_INTERNAL, isInternal });
    },
    clearRightPanel: () => {
      dispatch({ type: RIGHT_TOP, rightTop: '' });
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: '' });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Articles));
